import { cva } from 'class-variance-authority'

type SpacerSize =
  | '4px'
  | '8px'
  | '12px'
  | '16px'
  | '20px'
  | '24px'
  | '28px'
  | '32px'
  | '36px'
  | '40px'
  | '48px'
  | '56px'
  | '64px'
  | '72px'
  | '74px'
  | '80px'
  | '96px'
  | '112px'
  | '128px'
  | '144px'
  | '160px'

const spacerVariants = cva('', {
  variants: {
    size: {
      '4px': 'min-h-1',
      '8px': 'min-h-2',
      '12px': 'min-h-3',
      '16px': 'min-h-4',
      '20px': 'min-h-5',
      '24px': 'min-h-6',
      '28px': 'min-h-7',
      '32px': 'min-h-8',
      '36px': 'min-h-9',
      '40px': 'min-h-10',
      '48px': 'min-h-12',
      '56px': 'min-h-11',
      '64px': 'min-h-16',
      '72px': 'min-h-[4.5rem]',
      '74px': 'md:min-h-[4.625rem]',
      '80px': 'min-h-20',
      '96px': 'min-h-24',
      '112px': 'min-h-28',
      '128px': 'min-h-32',
      '144px': 'min-h-36',
      '160px': 'min-h-40',
    },
    sizeMd: {
      '4px': 'md:min-h-1',
      '8px': 'md:min-h-2',
      '12px': 'md:min-h-3',
      '16px': 'md:min-h-4',
      '20px': 'md:min-h-5',
      '24px': 'md:min-h-6',
      '28px': 'md:min-h-7',
      '32px': 'md:min-h-8',
      '36px': 'md:min-h-9',
      '40px': 'md:min-h-10',
      '48px': 'md:min-h-12',
      '56px': 'md:min-h-14',
      '64px': 'md:min-h-16',
      '72px': 'md:min-h-[4.5rem]',
      '74px': 'md:min-h-[4.625rem]',
      '80px': 'md:min-h-20',
      '96px': 'md:min-h-24',
      '112px': 'md:min-h-28',
      '128px': 'md:min-h-32',
      '144px': 'md:min-h-36',
      '160px': 'md:min-h-40',
    },
  },
})

/**
 * Adds vertical space with responsive sizes.
 *
 * It solves this problem of margins: It is not good to use margin on the component's top-level, because it breaks the isolation of components
 *
 * More details in https://javascript.plainenglish.io/stop-using-margin-use-spacer-component-instead-953d9b2dbacc
 */
export function Spacer({
  id,
  size,
  sizeMd,
  className,
}: {
  id?: string
  /**
   * size without media queries
   */
  size?: SpacerSize
  /**
   * @media (min-width: 768px)
   */
  sizeMd?: SpacerSize
  className?: string
}) {
  return <div id={id} className={spacerVariants({ size, sizeMd, className })} />
}
